import { SerializedStyles, Theme, css } from '@emotion/react';
import styled from '@emotion/styled';

export const passwordChecksContainer = (theme: Theme) => css`
    max-height: 400px;
    opacity: 1;
    display: flex;
    gap: 6px;
    background-color: ${theme.colors.secondary.alpha};
    color: ${theme.colors.default.initial};
    flex-flow: column nowrap;
    margin-bottom: 16px;
    border: 1px solid ${theme.colors.theme.alpha};
    padding: 16px;
    border-radius: 4px;
    position: relative;
`;

export const passwordChecksContainerHidden = css`
    opacity: 0;
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
`;

export const PasswordChecksContainer = styled.div<{ css: SerializedStyles[] }>`
    ${({ css }) => css};
`;

export const PasswordChecksRow = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    flex-flow: row nowrap;
`;
